import {Grid,} from "@mui/material";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Seccion_Opinion = () => {
    const { sCell } = useResponsive();

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{pt: sCell?11:15}}>
        </Grid>
    )
}
export default Seccion_Opinion;

